'use strict';

angular.module('receptionModule').component('receptionAllGroupsGuardians', {
    templateUrl:
    '/Scripts/app/reception/controllers/groups/reception-allgroups-guardians.template.html?v=', // + window.EveryBuddy.version
    bindings: {
        selectedGroup: '<'
    },
    controller:
    [
        '$scope',
        function ($scope) {

            this.$onChanges = (changes) => {
                if (changes.selectedGroup && changes.selectedGroup.currentValue) {
                    $scope.selectedGroup = this.selectedGroup;
                }
            };

        }
    ]});